/**
 * Stage 座位舞台
 * props:
 *  site:  座位数据
 *  siteEvent: 将选中的座位给到父组件
 * methods:
 *  limitRage 获取最大可拖动范围
 *  sitFilter 座位数据过滤
 *  screenFollow 放大后屏幕跟随
 *  clickHandler 座位点击后放大
 *  touchStartHandler 拖动开始
 *  touchMoveHandler 拖动中
 *  touchEndHandler 拖动结束
 */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import Detail from '../Site/Detail';
import Preview from '../Preview';
// import { reducer, defaultState } from '../context'
import useDragger from '@/hooks/useDragger';
import useXState from '@/hooks/useXState';
import SitCanvas from './SitCanvas';
import SitCanvasCompat from './SitCanvasCompat';
import { Context } from '../../index';
import {TLang } from '@/utils/lang';

const styles = require('./style/index.less');

import bg from '@/assets/imgs/group.png';

// export const Context = createContext(null) // 私有state
let time: any = null;
const Stage = (props) => {
  const { site, siteEvent, maxSit, love, activeIndex, single, leftIndexs } = props,
    siteLine: any = useRef(null), // 侧边座位排数
    screenRef: any = useRef(null),
    stageRef: any = useRef(null), // 舞台引用
    innerStage = useRef(null), // 座位引用
    content = useRef(null), // 容器引用
    [isTouch, setTouch] = useXState(false), // 是否触摸
    [reSitData, setReSiteData] = useState([...site]);
  const [size, setSize] = useState();
  const [move, setMove] = useState({});
  const [scale, setScale] = useState({w_s:1, h_s:1, w: 1, h:1});
  // const { state, dispatch } = useContext(Context);
  // useEffect(() => {
  //   console.log('value',state.value)
  //   siteEvent(state.value)  // 获取选中的座位信息
  // }, [state, siteEvent])

  useEffect(() => {
    // 渲染后屏幕缩放
    stageRef.current.addEventListener(
      'touchmove',
      (e) => {
        e.preventDefault();
      },
      {
        passive: false
      },
    );
  }, []);

  let limitRage = (content, substance, limit = 80) => {
    // 获取容器拖动的最大区域
    let contentRect = content.current.getClientRects();
    let innerRect = substance.current.getClientRects();

    let obj = {
      width: innerRect[0].width + limit * 2,
      height: innerRect[0].height + limit * 2,
      maxY: 0,
      minY:
        innerRect[0].height + limit >= contentRect[0].height
          ? contentRect[0].height - (innerRect[0].height + limit)
          : 0,
      maxX:
        innerRect[0].width + limit * 2 >= contentRect[0].width
          ? (innerRect[0].width + limit * 2) / 2 - contentRect[0].width / 2
          : 0,
      minX:
        innerRect[0].width + limit * 2 >= contentRect[0].width
          ? contentRect[0].width / 2 - (innerRect[0].width + limit * 2) / 2
          : 0
    };
    return obj;
  };

  const startHandler = (e, d) => {
    siteLine.current.style.setProperty('--transformY', `${d.y}px`);
  };
  const showPreview = () => {
    setTouch(true);
    window.clearTimeout(time); // preview 显示
    time = setTimeout(() => {
      setTouch(false); // 4秒后preview 隐藏
    }, 1000);
  };
  const moveHandler = (e, d) => {
    siteLine.current.style.setProperty('--transformY', `${d.y}px`);
    showPreview();
    setMove({...d});
  };
  const endHandler = (e, d) => {
    siteLine.current.style.setProperty('--transformY', `${d.y}px`);
  };

  const [stop] = useDragger(
    screenRef,
    () => limitRage(content, innerStage),
    [1, 0, 0],
    { zoom: false, moveLimit: true },
    startHandler,
    moveHandler,
    endHandler,
  );
  const [hasSit, setHasSit] = useState(false);

  const getCanvasZoom = useCallback(
    (scale) => {
      siteLine.current.style.setProperty('--scale', `${scale}`);
      setSize(scale);
    },
    [siteLine],
  );
  const getAreaZoom = useCallback(({ w, h }) => {
    if(content?.current){
      const ww = parseFloat(w);
      const hh = parseFloat(h);
      const cur : any = content.current;
      const contentWid = cur.offsetWidth;
      const contentHei = cur.offsetHeight;
      let w_scale = parseFloat((contentWid/ww).toFixed(2));
      let h_scale = parseFloat((contentHei/hh).toFixed(2));
      w_scale = w_scale > 1 ? 1:w_scale;
      h_scale = h_scale > 1 ? 1:h_scale;
      setScale({w_s:w_scale, h_s:h_scale, w:ww, h:hh});
    }
  }, [content]);

  const getSeledSit = useCallback((sit, sitdata) => {
    siteEvent(sit);
    setReSiteData([...sitdata]);
    showPreview();
    if (sit.length > 0) {
      setHasSit(true);
    } else {
      setHasSit(false);
    }
  }, []);
  const clickHandler = (e) => {
    showPreview();
  };

  return (
    <div className={styles.stage} ref={stageRef}>
      <div className={styles.stageBox}>
        <Preview data={reSitData} show={isTouch} Click={clickHandler} move={{...move, size: scale}} />
        <div className={styles.screen} alt={`${props.hallName}${TLang('荧幕', 'home', false, false, null)}`}>
          <img src={bg} alt="" />
        </div>
        <div className={styles.content} ref={content}>
          <ul className={styles.lineLeft} ref={siteLine}>
            {leftIndexs.map((ele, idx, arr) => (
              <li key={`${idx}${Math.random()}`}>{ele}</li>
            ))}
          </ul>
          <div className={styles.viewStage} ref={screenRef}>
            {/* <Context.Provider value={{ state, dispatch: dispatch }}> */}
            {/* 兼容层：在 iframe + 非触摸设备下，将 Pointer 事件转 Touch，以复用既有触摸逻辑 */}
            <SitCanvasCompat zoomTarget={screenRef} />
            <div ref={innerStage} className={styles.siteTable}>
              <SitCanvas
                zoomTarget={screenRef}
                data={site}
                key={site}
                maxSit={maxSit}
                getZoom={getCanvasZoom}
                getAreaScale={getAreaZoom}
                getSeledSit={getSeledSit}
                activeIndex={activeIndex}
              />
            </div>
            {/* </Context.Provider> */}
          </div>
        </div>
      </div>
      {hasSit === false ? <Detail love={love} single={single} /> : null}
    </div>
  );
};
export default Stage;
